import { CommonModule } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { MaterialModule } from '../../../material/material.module';

@Component({
    selector: 'app-rating-slider5',
    imports: [CommonModule, MaterialModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RatingSlider5Component),
            multi: true
        }
    ],
    templateUrl: './rating-slider5.component.html',
    styleUrl: './rating-slider5.component.css'
})
export class RatingSlider5Component implements ControlValueAccessor {

  value: number = 0;
  disabled: boolean = false;

  onChange: any = () => {};
  onTouch: any = () => {};

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateValue(event: Event): void {
    const newValue = (event.target as HTMLInputElement).valueAsNumber;
    this.value = newValue;
    this.onChange(newValue);
    this.onTouch();
  }

  

  getText(value: number): string {
    if (value >= 1 && value <= 5) {
      return value.toString();
    }

    return '';
  }

onInput(event: any) {
  this.value = event.value;
}
}
